import { computed, type Ref } from 'vue'
import { parseLocalDate } from '@/utils/date'

export function useScheduleMaxDate(scheduleEndDate: Ref<string | null | undefined>) {
  const scheduleMaxDate = computed(() => {
    if (!scheduleEndDate.value) return null
    return parseLocalDate(scheduleEndDate.value.slice(0, 10))
  })

  return { scheduleMaxDate }
}
